import React, { useEffect, useState } from "react";
import "./style.css";
import { useUsersContext } from "../../../../context/usersContext";
import { useUserInfo } from "../../../../context/user";
import { useAppServices } from "../../../../hook/services";
import env from "../../../../config/env";
import { loadStripe } from "@stripe/stripe-js";
import { useHttp } from "../../../../common/hooks/useHttp";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InvoiceModal from "./component/InvoiceModal";
import EditPaymentMethod from "./component/EditPaymentMethodModal";
import EditBillingInfoModal from "./component/EditBillingInfoModal";
import BuyTokensModal from "./component/BuyTokensModal";
import AITasksCard from "./component/AITasksCard";
import AddIcon from "@mui/icons-material/Add";
import format from "date-fns/format";
import CancelModal from "./component/CancelModal";
import CancelConfirmModal from "./component/CancelConfirmModal";
import ContactToSupportModal from "../../../../components/ContactToSupportModal";

function TeamContent({ setActiveTab }) {
  const AppService = useAppServices();
  const user = useUserInfo()[0];
  const [, SetAgency] = useState({});
  const userActiveLocation = useUserInfo()[4];
  const Update = useUserInfo()[5];
  const [accountbalance, SetAccountbalance] = useState(0);
  const [accountbalancelogs, SetAccountbalancelogs] = useState([]);
  const [reloadstatus, SetReloadstatus] = useState(false);
  const [stripePromise, SetstripePromise] = useState("");
  const [autoChargeAmount, setAutoChargeAmount] = useState(0);
  const [lowBalance, setLowBalance] = useState(0);
  const { getLocationUsers, products, agency } = useUsersContext();
  const [addAddUerModalOpen, setAddUserModalOpen] = useState(false);
  const [isOpenInvoiceModal, setIsOpenInvoiceModal] = useState(false);
  const [invoicesData, setInvoicesData] = useState([]);
  const [paymentInformation, setPaymentInformation] = useState();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [openPaymentMethodModal, setOpenPaymentMethodModal] = useState(false);
  const [openBillingInfoModal, setOpenBillingInfoModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openBuyTokensModal, setOpenBuyTokensModal] = useState(false);
  const [aiTokenPurchases, setAiTokenPurchases] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    lastName: "",
    email: "",
    contactNumber: "",
  });
  const [paymentMethodTitle, setPaymentMethodTitle] = useState("");
  const activePlan = products?.filter((product) => product?.activePlan)[0];
  const [openSupportModal, setOpenSupportModal] = useState(false);

  const handlePaymentMethodModal = (isEdit = false) => {
    setPaymentMethodTitle(
      isEdit ? "Edit Payment Method" : "Add Payment Method",
    );
    setOpenPaymentMethodModal(!openPaymentMethodModal);
  };

  const handleBillingInfoModal = () => {
    setOpenBillingInfoModal(!openBillingInfoModal);
  };

  const loadPaymentAndInvoices = async () => {
    const [paymentInfo, invoices, subscription, aiPurchases] = await Promise.all([
      AppService.subscription.getPaymentInfoByAgencyId({
        agency_id: userActiveLocation?.agency_id,
        customer_id: userActiveLocation?.customer_id,
      }),
      AppService.subscription.getInvoicesByAgencyId({
        agency_id: userActiveLocation?.agency_id,
        customer_id: userActiveLocation?.customer_id,
      }),
      AppService.subscription.getSubscriptionsBySubscriptionId({
        subscription_id: userActiveLocation?.subscription_id,
        agency_id: userActiveLocation?.agency_id,
      }),
      AppService.accounts.getAITokenPurchases({
        payload: { account_id: userActiveLocation?._id },
      }),
    ]);

    if (paymentInfo?.response?.data) {
      setPaymentInformation(paymentInfo?.response?.data);
    }
    if (invoices?.response?.data?.data) {
      setInvoicesData(invoices?.response.data.data);
    }
    if (subscription?.response?.data) {
      setSubscription(subscription?.response?.data);
    }
    if (Array.isArray(aiPurchases?.response?.data)) {
      setAiTokenPurchases(aiPurchases.response.data);
    }
  };

  useEffect(() => {
    loadPaymentAndInvoices();
  }, [refetch]);

  useEffect(() => {
    const refreshAccount = async () => {
      if (!userActiveLocation?.id) return;
      const { response } = await AppService.accounts.getbyid({
        query: `id=${userActiveLocation.id}`,
      });
      if (response?.data) Update(response.data);
    };
    refreshAccount();
    const interval = setInterval(refreshAccount, 15000);
    return () => clearInterval(interval);
  }, [userActiveLocation?.id, refetch]);

  const justCloseIt = () => {
    setAddUserModalOpen(false);
  };

  const handleAddUserModal = (e) => {
    e.preventDefault();
    setAddUserModalOpen(true);
  };
  const handleAutoCharge = async (e) => {
    const payload = {
      auto_charge: e.target.value,
      _id: userActiveLocation?.id,
    };
    const { response } = await AppService.accounts.update({
      payload,
      toaster: true,
    });
    if (response) {
      setAutoChargeAmount(response?.data?.auto_charge);
      Update(response.data);
    }
  };
  const handleLowBalance = async (e) => {
    const payload = {
      low_balancs_limit: e.target.value,
      _id: userActiveLocation?.id,
    };
    const { response } = await AppService.accounts.update({
      payload,
      toaster: true,
    });
    if (response) {
      setLowBalance(response?.data?.low_balancs_limit);
      Update(response.data);
    }
  };

  const getBalance = async () => {
    if (!userActiveLocation?.id) return;
    const { response } = await AppService.accounts.getBalance({
      payload: { id: userActiveLocation.id },
    });
    if (response?.data) {
      SetAccountbalance(response.data.amount ?? 0);
      setAutoChargeAmount(response.data.auto_chart ?? 0);
      setLowBalance(response.data.low_balancs_limit ?? 0);
      SetReloadstatus(false);
    }
  };
  const getBalanceLogs = async () => {
    const payload = {
      account_id: userActiveLocation?.id,
      agency_id: userActiveLocation?.agency_id,
    };
    const { response } = await AppService.accounts.getBalanceLogs({
      payload,
      toaster: true,
    });
    if (response) {
      SetAccountbalancelogs(response.data);
      SetAgency(response.agency);
      SetstripePromise(loadStripe(response.agency?.stripe?.publish_key));
      SetReloadstatus(false);
    }
  };
  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };
  const getLogMessage = (log) => {
    if (log.type === "credit") {
      return `Received new amount of <b style="color:green">$${log.amount
        }</b> on <b>${log.req_type}   <br>${formatDate(log.createdAt)}  ${log.response.status
        }</b>`;
    } else if (log.type === "debit") {
      return `Paid amount of <b style="color:red">$${log.amount}</b> on <b>${log.req_type
        }  <br>${formatDate(log.createdAt)} ${log.response.status}</b>`;
    } else {
      return `Unknown transaction type`;
    }
  };
  useEffect(() => {
    getBalance();
    getBalanceLogs();
  }, [reloadstatus, refetch]);
  const BASE_URL = `${env.API_URL}/v1`;

  const location = useUserInfo();
  const agencyData = useUserInfo()[11];
  const { sendRequest: getEventData } = useHttp();
  const [totalMatchLocationfromchat, setTotalMatchLocationfromchat] =
    useState(0);
  const getdata = () => {
    const location_id = location;
    getEventData(
      {
        url: `${BASE_URL}/chat/get_data_by_location/${location_id._id}`,
        method: "GET",
        payload: {},
      },
      async (response) => {
        setTotalMatchLocationfromchat(response.data.length);
      },
    );
  };

  const formatAmount = (amount, currency) => {
    const sym = (currency || "usd").toUpperCase() === "GBP" ? "£" : "$";
    return `${sym}${Number(amount || 0).toFixed(2)}`;
  };

  const paymentRows = [
    ...(invoicesData || [])?.map((item) => ({
      id: `inv_${item.id}`,
      type: "invoice",
      date: item.created ? new Date(item.created * 1000) : new Date(0),
      description:
        item.description || item.lines?.data?.[0]?.description || "Invoice",
      amount: formatAmount((item.amount_paid || 0) / 100, item.currency),
      status: item.status,
      raw: item,
    })),
    ...(aiTokenPurchases || [])
      .filter((p) => p?.status === "succeeded")
      .map((p) => ({
        id: `ai_${p._id}`,
        type: "ai_tokens",
        date: p.createdAt ? new Date(p.createdAt) : new Date(0),
        description: p.description || `${p.tokens} Bulk AI Task`,
        amount: formatAmount(p.amount, p.currency),
        status: "paid",
        raw: p,
      })),
  ].sort((a, b) => b.date - a.date);

  const handleChangePlanClick = () => {
    if (userActiveLocation?.type !== 'free' && (activePlan?.isenable_account || activePlan?.developer_plan)) {
      setActiveTab("Pricing");
    } else {
      setOpenSupportModal(true);
    }
  };

  useEffect(() => {
    getdata();
  }, []);
  console.log("invoicesData", invoicesData);
  return (
    <>
      <div>
        <b className="text-lg font-bold">Billing</b>

        <div className="flex gap-4 mt-9">
          <div className="p-6 w-[320px] bg-white rounded-[5px] shadow-md border !border-[#D9D9D9]">
            <div className="flex justify-between items-center my-[6.5px]">
              <b>{activePlan?.plan?.planName}</b>

              <span className="text-[12px] px-[25px] py-[5px] bg-[#CFF7D3] text-[#02542D] rounded-[50px]">
                Active
              </span>
            </div>

            <p className="text-sm py-[11px]">
              {`Your current billing cycle ends on ${subscription
                  ? format(
                    new Date(subscription?.current_period_end * 1000),
                    "MMMM dd, yyyy",
                  )
                  : ""
                }.`}
            </p>

            <button
              className="text-sm py-2 w-full bg-[#2C2C2C] rounded-[5px] text-white"
              onClick={handleChangePlanClick}
            >
              Change Plan
            </button>
            {!activePlan?.is_free_saas && (
              <button
                className="text-sm py-1 w-full mt-2"
                onClick={() => setOpenCancelModal(true)}
              >
                Cancel plan
              </button>
            )}
          </div>

          <div className="p-6 w-[320px] bg-white rounded-[5px] shadow-md border !border-[#D9D9D9]">
            <div className="flex justify-between items-center my-[6.5px]">
              <b>Payment Method</b>
              {paymentInformation?.card ? (
                <CreateOutlinedIcon
                  color="#757575"
                  className=" text-[#757575] cursor-pointer"
                  onClick={() => handlePaymentMethodModal(true)}
                />
              ) : (
                <AddIcon
                  color="primary"
                  className="text-[#757575] cursor-pointer"
                  onClick={() => handlePaymentMethodModal(false)}
                />
              )}
            </div>

            {paymentInformation?.card ? (
              <div className="flex gap-2 items-center">
                <CreditCardOutlinedIcon className="text-xl" />
                <div>
                  <p className="text-sm">
                    {paymentInformation?.card?.brand} ****{" "}
                    {paymentInformation?.card?.last4}{" "}
                  </p>
                  <p className="text-[#757575] text-[12px]">
                    Expires {paymentInformation?.card?.exp_month}/
                    {paymentInformation?.card?.exp_year}
                  </p>
                </div>
              </div>
            ) : (
              <div className="flex gap-2 items-center text-[#757575] text-sm mt-4">
                No payment method added
              </div>
            )}
          </div>

          {paymentInformation && (
            <div className="p-6 w-[320px] bg-white rounded-[5px] shadow-md border !border-[#D9D9D9]">
              <div className="flex justify-between items-center my-[6.5px]">
                <b>Billing Information</b>
                <CreateOutlinedIcon
                  color="#757575"
                  className=" text-[#757575] cursor-pointer"
                  onClick={() => handleBillingInfoModal(true)}
                />
              </div>

              <div className="flex gap-2 items-center">
                <CreditCardOutlinedIcon className="text-xl" />

                <div>
                  <p className="text-sm">
                    {paymentInformation?.billing_details?.name}
                  </p>
                  <p className="text-[#757575] text-[12px]">
                    {paymentInformation?.billing_details?.address?.line1}
                    {", "}
                    {paymentInformation?.billing_details?.address?.line2}
                    {", "}
                    {paymentInformation?.billing_details?.address?.city}
                    {", "}
                    {paymentInformation?.billing_details?.address?.state}
                    {", "}
                    {paymentInformation?.billing_details?.address?.country}
                    {", "}
                    {paymentInformation?.billing_details?.address?.postal_code}
                  </p>
                </div>
              </div>
            </div>
          )}

          <AITasksCard
            userActiveLocation={userActiveLocation}
            subscription={subscription}
            onBuyClick={() => setOpenBuyTokensModal(true)}
          />
        </div>

        <div className="mt-10">
          <div className="flex justify-between items-center">
            <h1 className="text-lg font-bold">Payment History</h1>
          </div>

          <div>
            <table style={{ width: "100%" }}>
              <div className="table_heading">

                <p
                  className="td_border text-sm !text-[#757575]"
                  style={{ padding: "21px", width: "20%", textAlign: "center" }}
                >
                  Due Date
                </p>
                <p
                  className="td_border text-sm !text-[#757575]"
                  style={{ padding: "21px", width: "20%", textAlign: "center" }}
                >
                  Description
                </p>
                <p
                  className="td_border text-sm !text-[#757575]"
                  style={{ padding: "21px", width: "20%", textAlign: "center" }}
                >
                  Amount
                </p>
                <p
                  className="td_border text-sm !text-[#757575]"
                  style={{ padding: "21px", width: "20%", }}
                >
                  Status
                </p>
                <p
                  className="td_border text-sm !text-[#757575]"
                  style={{ padding: "21px", width: "20%", textAlign: "center" }}
                ></p>
                <p
                  className="td_border text-sm !text-[#757575]"
                  style={{ padding: "21px", width: "20%", textAlign: "center" }}
                ></p>
              </div>

              {paymentRows.length ? (
                paymentRows.map((row) => (
                  <div
                    key={row.id}
                    className="table_body items-center"
                    style={{ background: "#FFFFFF" }}
                  >


                    <p
                      className="td_border "
                      style={{ padding: "21px", width: "20%", textAlign: "center" }}
                    >
                      {format(row.date, "MMMM dd, yyyy")}
                    </p>

                    <p
                      className="td_border"
                      style={{ padding: "21px", width: "20%", textAlign: "center" }}
                    >
                      {row.description}
                    </p>

                    <p
                      className="td_border"
                      style={{ padding: "21px", width: "20%", textAlign: "center" }}
                    >
                      {row.amount}
                    </p>

                    <div
                      className="td_border"
                      style={{ padding: "21px", width: "20%", textAlign: "center" }}
                    >
                      <p
                        className={` ${row.status === "paid"
                            ? "bg-[#CFF7D3]"
                            : "bg-[#FFF1C2]"
                          } px-[15px] rounded-full capitalize !w-fit !h-[27px] flex justify-center items-center !text-[12px]`}
                        style={{ padding: "21px", width: "20%" }}
                      >
                        {row.status}
                      </p>
                    </div>

                    {row.type === "invoice" ? (
                      <p
                        onClick={() => {
                          setIsOpenInvoiceModal(true);
                          setSelectedInvoice(row.raw);
                        }}
                        className="td_border text-center cursor-pointer "
                        style={{ padding: "21px", width: "20%", textAlign: "center" }}
                      >
                        View
                      </p>
                    ) : (
                      <p
                        className="td_border text-center text-[#9CA3AF]"
                        style={{ padding: "21px", width: "20%", textAlign: "center" }}
                      >
                        —
                      </p>
                    )}

                    <p
                      className="td_border"
                      style={{
                        padding: "21px",
                        width: "20%",
                        paddingRight: "35px",
                        textAlign: "right",
                        display: "flex",
                        justifyContent: "right",
                        alignItems: "center",
                      }}
                    >
                      {row.type === "invoice" && row.raw?.invoice_pdf && (
                        <a
                          href={row.raw.invoice_pdf}
                          target="_blank"
                          download={`invoice_${row.raw.id || "000000"}.pdf`}
                          rel="noreferrer"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            width: "20px",
                            height: "20px",
                            marginRight: "8px",
                          }}
                        >
                          <FileDownloadOutlinedIcon className="text-[25px] text-[#1E1E1E]" />
                        </a>
                      )}
                    </p>
                  </div>
                ))
              ) : (
                <>
                  <tr>
                    <td colSpan={7} className="text-center py-4">
                      No invoices found.
                    </td>
                  </tr>
                </>
              )}
            </table>
          </div>
        </div>
        <InvoiceModal
          setIsOpenInvoiceModal={setIsOpenInvoiceModal}
          isOpenInvoiceModal={isOpenInvoiceModal}
          invoices={selectedInvoice}
        />
        <EditPaymentMethod
          isOpen={openPaymentMethodModal}
          onClose={handlePaymentMethodModal}
          title={paymentMethodTitle}
          agency={agency}
          setRefetch={setRefetch}
          userActiveLocation={userActiveLocation}
        />
        {openBillingInfoModal && (
          <EditBillingInfoModal
            isOpen={openBillingInfoModal}
            onClose={handleBillingInfoModal}
            paymentMethod_id={paymentInformation?.id}
            billing_details={paymentInformation?.billing_details}
            setRefetch={setRefetch}
            userActiveLocation={userActiveLocation}
          />
        )}
        {openCancelModal && (
          <CancelModal
            isOpen={openCancelModal}
            onClose={() => {
              setOpenCancelModal(false);
            }}
            setOpenConfirmModal={setOpenConfirmModal}
          />
        )}
        {openConfirmModal && (
          <CancelConfirmModal
            isOpen={openConfirmModal}
            onClose={() => setOpenConfirmModal(false)}
          />
        )}
        <BuyTokensModal
          isOpen={openBuyTokensModal}
          onClose={() => setOpenBuyTokensModal(false)}
          userActiveLocation={userActiveLocation}
          onPurchased={(updatedAccount) => {
            if (updatedAccount) Update(updatedAccount);
            setRefetch((r) => !r);
          }}
        />
      </div>
      {openSupportModal && (
        <ContactToSupportModal
          isOpen={openSupportModal}
          onClose={() => setOpenSupportModal(false)}
        />
      )}
    </>
  );
}

export default TeamContent;
